class NavLink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Called when component is added to the DOM
    this.init();
  }

  init() {
    const link = this.querySelector('a');
    
    if (!link) return;

    // Example: add active class when clicked
    link.addEventListener('click', () => {
      document.querySelectorAll('nav-link').forEach(nav=>{
        nav.classList.remove('is-active');
      })
      this.classList.add('is-active');
    });
  }
}

customElements.define('nav-link', NavLink);
